import moment from 'moment';
import { isNullOrEmpty } from '../utilities';
import { InvalidArgumentTypeException } from '../exceptions';
export class DateTime {
    constructor(value) {
        if (value instanceof Date) {
            this._value = moment(value);
        }
        else {
            if (isNullOrEmpty(value)) {
                throw Error('ArgumentNullException: value');
            }
            value = value.trim();
            switch (value.length) {
                case 10:
                    this._value = moment(value, 'DD/MM/yyyy');
                    break;
                case 16:
                    this._value = moment(value, 'DD/MM/yyyy hh:mm');
                    break;
                case 19:
                    this._value = moment(value, 'DD/MM/yyyy hh:mm:ss');
                    break;
                default:
                    throw Error('InvalidArgumentException: value');
            }
        }
    }
    static get Now() {
        const date = moment().locale('es').format('DD/MM/yyyy hh:mm:ss');
        return new DateTime(date);
    }
    ToString(format) {
        return this._value.format(format);
    }
    ToJsDate() {
        return this._value.toDate();
    }
    TruncateDate() {
        const tmp = this._value.format('DD/MM/yyyy');
        return moment(tmp, 'DD/MM/yyyy').toDate();
    }
    AddHours(hours) {
        if (isNaN(hours))
            throw new InvalidArgumentTypeException('hours', 'number');
        const newDate = this._value.add(hours, 'hours').toDate();
        return new DateTime(newDate);
    }
    AddDays(days) {
        if (isNaN(days))
            throw new InvalidArgumentTypeException('days', 'number');
        const newDate = this._value.add(days, 'days').toDate();
        return new DateTime(newDate);
    }
    get Date() {
        return new DateTime(this.ToString("DD/MM/yyyy"));
    }
}
